import { render, staticRenderFns } from "./vista_previa.vue?vue&type=template&id=471ef0b6"
import script from "./vista_previa.vue?vue&type=script&lang=js"
export * from "./vista_previa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports